import { colors, makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    color: 'white',
    textTransform: 'uppercase',
  },
  suggested: {
    backgroundColor: theme.palette.trailWarning,
  },
  disapproved: {
    backgroundColor: colors.red[500],
  },
}))

export default styles
